import {Routes, Route} from 'react-router-dom';
import React from 'react';
import PriceList from './PriceList';   
import { Fragment } from 'react';
import Nav from './Nav';
import Symbol from './Symbol';
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import '../index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {connect} from 'react-redux';
const App: React.FC = (props : any)=> {
  useEffect(() => {
    // Perform any necessary setup or data fetching here
    console.log('App component mounted');
    
  }, []);
  return (
    <Fragment>
      <div className="App">
        <Nav/>
      <div className='container-fluid'>
        <Routes>
            <Route path="/" element={<h2>Welcome to the Stock Dashboard</h2>} />
            <Route path="/price-list" element={<PriceList />} />
            <Route path="/symbol/:symbol" element={<Symbol />} />
        </Routes>
      </div>
      </div>
    </Fragment>
  );
}
const mapStateToProps = (state: any) => {
  console.log(state)
  return state;
};
export default connect(mapStateToProps)(App);
